export const devInfo = {
  isDingTalkDevice: navigator && /DingTalk/.test(navigator.userAgent),
};
